/**
 * 問い合わせフォーム：「配送先の変更/注文キャンセルについて」選択時の案内ポップアップ
 *
 * 確認ボタンの click を capture フェーズでインターセプトし、
 * 該当カテゴリ選択時にのみ案内モーダルを表示する。
 * 「問い合わせを続ける」押下後は通常フロー（バリデーション→確認画面）に委譲する。
 *
 * 前提:
 *   - bundle.js (webpack) の InquiryContactPage が DOMContentLoaded で
 *     確認ボタンに jQuery click ハンドラを登録済み
 *   - このスクリプトは template から defer で読み込まれ、同じく DOMContentLoaded で
 *     capture フェーズにリスナーを登録する（jQuery のバブルハンドラより先に発火）
 */
(function () {
  'use strict';

  var CATEGORY_VALUE = '配送先の変更/注文キャンセルについて';
  var MODAL_ID = 'mirutoShippingCancelPopup';
  var STYLE_ID = 'mirutoShippingCancelStyle';

  function helpcenterAccountUrl() {
    var page = document.querySelector('.contactPage.--inquiry');
    return (page && page.getAttribute('data-helpcenter-account-url')) || '';
  }

  // ──────────────────────────────────────────────────────────────
  // スタイル注入
  // ──────────────────────────────────────────────────────────────
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.mirutoModalOverlay{position:fixed;inset:0;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;z-index:99999;padding:16px;}' +
      '.mirutoModal{background:#fff;width:min(520px,100%);border-radius:16px;padding:22px 18px 18px;position:relative;box-shadow:0 12px 30px rgba(0,0,0,.18);}' +
      '.mirutoModal__close{position:absolute;top:10px;right:10px;width:36px;height:36px;border:none;background:transparent;font-size:22px;line-height:1;cursor:pointer;}' +
      '.mirutoModal__title{font-size:18px;font-weight:700;margin:0 0 10px;}' +
      '.mirutoModal__desc{margin:0 0 14px;font-size:14px;line-height:1.7;}' +
      '.mirutoModal__desc a{color:#1a73e8;text-decoration:underline;}' +
      '.mirutoModal__btnWrap{display:flex;gap:8px;}' +
      '.mirutoModal__btn{display:block;flex:1;text-align:center;padding:12px 14px;border-radius:12px;background:#111;color:#fff;text-decoration:none;font-weight:700;border:none;cursor:pointer;}' +
      '.mirutoModal__btn.--secondary{background:#fff;color:#111;border:1px solid #ccc;}';
    document.head.appendChild(style);
  }

  // ──────────────────────────────────────────────────────────────
  // フォーカストラップ
  // ──────────────────────────────────────────────────────────────
  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  // ──────────────────────────────────────────────────────────────
  // モーダル表示
  // ──────────────────────────────────────────────────────────────
  function showPopup() {
    return new Promise(function (resolve) {
      injectStyle();

      var existing = document.getElementById(MODAL_ID);
      if (existing) existing.remove();

      var overlay = document.createElement('div');
      overlay.className = 'mirutoModalOverlay';
      overlay.id = MODAL_ID;
      overlay.innerHTML =
        '<div class="mirutoModal" role="dialog" aria-modal="true" aria-labelledby="shippingCancelTitle">' +
          '<button type="button" class="mirutoModal__close" aria-label="閉じる">&times;</button>' +
          '<h3 class="mirutoModal__title" id="shippingCancelTitle">ご案内</h3>' +
          '<p class="mirutoModal__desc">' +
            // 遷移先はヘルプセンターの「アカウント・契約情報について」。URL は templates/page.contact.inquiry.liquid が snippets/helpcenter-url.liquid から出す
            '定期購買の住所変更は<a href="' + helpcenterAccountUrl() + '" target="_blank" rel="noopener">こちら</a>をご確認ください。' +
            '注文後の住所変更またはキャンセルは発送状況によって対応しかねる場合がございます。' +
          '</p>' +
          '<div class="mirutoModal__btnWrap">' +
            '<button type="button" class="mirutoModal__btn --secondary" data-action="back">戻る</button>' +
            '<button type="button" class="mirutoModal__btn" data-action="continue">問い合わせを続ける</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      var modal = overlay.querySelector('.mirutoModal');
      var removeTrap = trapFocus(modal);
      var closeBtn = overlay.querySelector('.mirutoModal__close');
      setTimeout(function () { closeBtn.focus(); }, 0);

      var settled = false;
      function close(result) {
        if (settled) return;
        settled = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onEscape);
        removeTrap();
        overlay.remove();
        resolve(result);
      }

      function onEscape(e) { if (e.key === 'Escape') close(false); }
      document.addEventListener('keydown', onEscape);

      closeBtn.addEventListener('click', function () { close(false); });
      overlay.querySelector('[data-action="back"]').addEventListener('click', function () { close(false); });
      overlay.querySelector('[data-action="continue"]').addEventListener('click', function () { close(true); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(false); });
    });
  }

  // ──────────────────────────────────────────────────────────────
  // 確認ボタン インターセプト
  // ──────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var page = document.querySelector('.contactPage.--inquiry[data-form-v2]');
    if (!page) return;

    var confirmBtn = page.querySelector('[data-state="input"] .--button .c-button');
    if (!confirmBtn) return;

    var bypassing = false;

    confirmBtn.addEventListener('click', function (e) {
      if (bypassing) {
        bypassing = false;
        return; // 通常フロー（バリデーション→確認画面）へ委譲
      }

      var select = page.querySelector('[name="inquiryCategory"]');
      if (!select || select.value !== CATEGORY_VALUE) return; // 他カテゴリは通常フローへ

      e.stopImmediatePropagation();

      showPopup().then(function (confirmed) {
        if (confirmed) {
          bypassing = true;
          confirmBtn.click();
        }
      });
    }, true); // capture フェーズで jQuery ハンドラより先に発火
  });
})();
